var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _templateObject = _taggedTemplateLiteral(['\n    display: flex;\n    padding: 45px;\n    justify-content: center;\n    '], ['\n    display: flex;\n    padding: 45px;\n    justify-content: center;\n    ']);

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

/* eslint-disable eqeqeq */
import React, { useEffect, useState, useRef } from 'react';
import { Row, Col, Container, Button, Table, Tabs, Tab } from "react-bootstrap";
import axios from 'axios';
import NumberFormat from 'react-number-format';
import PulseLoader from "react-spinners/PulseLoader";
import { css } from "@emotion/core";
import { useDispatch } from "react-redux";
import { countryStateUpdate, DownPaymentInUSDsUpdate, stateCountyUpdate } from "../store/actions";
import { ApplyNow } from "applynow";
import ThemeConfig from "../modules/ThemeConfig";
import PriceForStateConfig from "../modules/PriceForState";

import { UserSession } from 'usersession';

// const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop, {behavior: 'smooth'})   
// General scroll to element function

export default function RatesData(props) {

    var userSession = new UserSession();
    var themeConfig = new ThemeConfig(props);
    var priceForStateConfig = new PriceForStateConfig(userSession.getPropertyState());
    var themeLeadSource = themeConfig.requestRates.leadSource;

    var _useState = useState(false),
        _useState2 = _slicedToArray(_useState, 2),
        loading = _useState2[0],
        setLoading = _useState2[1];

    var _useState3 = useState(false),
        _useState4 = _slicedToArray(_useState3, 2),
        noCCProgram = _useState4[0],
        setNoCCProgram = _useState4[1];

    var _useState5 = useState(""),
        _useState6 = _slicedToArray(_useState5, 2),
        loanTypeName = _useState6[0],
        setLoanTypeName = _useState6[1];

    var _useState7 = useState(""),
        _useState8 = _slicedToArray(_useState7, 2),
        countyName = _useState8[0],
        setCountyName = _useState8[1];

    var _useState9 = useState(""),
        _useState10 = _slicedToArray(_useState9, 2),
        countyCode = _useState10[0],
        setCountyCode = _useState10[1];

    var _useState11 = useState(""),
        _useState12 = _slicedToArray(_useState11, 2),
        propTypeName = _useState12[0],
        setPropTypeName = _useState12[1];

    var _useState13 = useState(""),
        _useState14 = _slicedToArray(_useState13, 2),
        propUsed = _useState14[0],
        setPropUsed = _useState14[1];

    var _useState15 = useState(0),
        _useState16 = _slicedToArray(_useState15, 2),
        ltv = _useState16[0],
        setLtv = _useState16[1];

    var todayDate = new Date(); //Today date
    var shortDate = new Intl.DateTimeFormat('en-US').format(todayDate);
    var myRefRD = useRef(null);

    var _useState17 = useState([]),
        _useState18 = _slicedToArray(_useState17, 2),
        productsList = _useState18[0],
        setProductsList = _useState18[1];

    var dispatch = useDispatch();

    var _useState19 = useState(localStorage.getItem('checkedTab') !== "" ? localStorage.getItem('checkedTab') : 'conventional'),
        _useState20 = _slicedToArray(_useState19, 2),
        tabKey = _useState20[0],
        setTabKey = _useState20[1];

    var override = css(_templateObject);
    /*06-27-2020 Jay Binod Singh WEB-45 Added below section to call api and assign and display on response 
      for Conventinal/FHA/VAJBS Rate data
      Added below till line 83 to call API and store data to display on page same as landing page
      */

    var _useState21 = useState(true),
        _useState22 = _slicedToArray(_useState21, 2),
        showCvnRates = _useState22[0],
        setCvnRates = _useState22[1];

    var _useState23 = useState(false),
        _useState24 = _slicedToArray(_useState23, 2),
        showFHARates = _useState24[0],
        setFHARates = _useState24[1];

    var _useState25 = useState(false),
        _useState26 = _slicedToArray(_useState25, 2),
        showVARates = _useState26[0],
        setVARates = _useState26[1];

    var _useState27 = useState(false),
        _useState28 = _slicedToArray(_useState27, 2),
        showUsdaRates = _useState28[0],
        setUsdaRates = _useState28[1];

    var _useState29 = useState(true),
        _useState30 = _slicedToArray(_useState29, 2),
        show = _useState30[0],
        setShow = _useState30[1]; //  -----------> Currently hard coded to show the Rates section by default
    /* States to set the received data from Pricing */


    var _useState31 = useState(""),
        _useState32 = _slicedToArray(_useState31, 2),
        conv15A = _useState32[0],
        setConv15A = _useState32[1];

    var _useState33 = useState(""),
        _useState34 = _slicedToArray(_useState33, 2),
        conv30A = _useState34[0],
        setConv30A = _useState34[1];

    var _useState35 = useState(""),
        _useState36 = _slicedToArray(_useState35, 2),
        fha15A = _useState36[0],
        setFha15A = _useState36[1];

    var _useState37 = useState(""),
        _useState38 = _slicedToArray(_useState37, 2),
        fha30A = _useState38[0],
        setFha30A = _useState38[1];

    var _useState39 = useState(""),
        _useState40 = _slicedToArray(_useState39, 2),
        va15A = _useState40[0],
        setVa15A = _useState40[1];

    var _useState41 = useState(""),
        _useState42 = _slicedToArray(_useState41, 2),
        va30A = _useState42[0],
        setVa30A = _useState42[1];

    var _useState43 = useState(""),
        _useState44 = _slicedToArray(_useState43, 2),
        usda15A = _useState44[0],
        setUsda15A = _useState44[1];

    var _useState45 = useState(""),
        _useState46 = _slicedToArray(_useState45, 2),
        usda30A = _useState46[0],
        setUsda30A = _useState46[1];

    var loanAmount = "";

    var _useState47 = useState(""),
        _useState48 = _slicedToArray(_useState47, 2),
        defaultTab = _useState48[0],
        setDefaultTab = _useState48[1];

    /*
    Dennis, right now the implementation is not generic. This is not how I wanted it implemented  
    
    */

    var handleResultsProdTabs = function handleResultsProdTabs(key) {
        setTabKey(key);

        if (key == 'conventional') {
            setCvnRates(true);
            setFHARates(false);
            setVARates(false);
            setUsdaRates(false);
            localStorage.setItem('checkedTab', 'conventional');
        } else if (key == 'fha') {
            setCvnRates(false);
            setFHARates(true);
            setVARates(false);
            setUsdaRates(false);
            localStorage.setItem('checkedTab', 'fha');
        } else if (key == 'va') {
            setCvnRates(false);
            setFHARates(false);
            setVARates(true);
            setUsdaRates(false);
            localStorage.setItem('checkedTab', 'va');
        } else if (key === 'usda') {
            setCvnRates(false);
            setFHARates(false);
            setVARates(false);
            setUsdaRates(true);
            localStorage.setItem('checkedTab', 'usda');
        }
    };
    /* End of States to set the received data from Pricing */

    useEffect(function () {
        // Set the no closing cost variable	
        setNoCCProgram(userSession.getNoClosingCosts());

        if (userSession.getPurchasePrice() == 0) {
            dispatch(DownPaymentInUSDsUpdate(0));
            userSession.setDownPaymentAmount(0);
        }

        var zipCode = userSession.getPropertyZipCode();
        if (zipCode.length == 5) {
            setLoading(true);
            axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_ZIPCODE + zipCode, "", {
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                setCountyName(response.data.counties[0].name);
                setCountyCode(response.data.counties[0].code);
                userSession.setPropertyCounty(response.data.counties[0].code);
                dispatch(stateCountyUpdate(response.data.counties[0].code));

                userSession.setPropertyState(response.data.state);
                dispatch(countryStateUpdate(response.data.state));
            });
        }

        if (zipCode.length < 5) {
            axios.get(process.env.REACT_APP_SUNSOFT_RESTSERVER_STATE_COUNTY_PUBLIC + userSession.getPropertyCounty(), {
                headers: { 'Content-Type': 'application/json' }
            }).then(function (response) {
                setCountyName(response.data.countyName);
            });
        }
        // Below switch statement set the loan type name that in the no match product table
        switch (userSession.getLoanPurpose()) {
            case "0":
                setLoanTypeName("Purchase");
                break;
            case "1":
                setLoanTypeName("Refinance");

                break;
            case "2":
                setLoanTypeName("Cash Out Refi");
                break;
            //no default
        }
        // Below switch statement set the property type name in the no match product table
        switch (userSession.getPropertyType()) {
            case "SFR":
                setPropTypeName("Single Family");
                break;
            case "CONDO":
                setPropTypeName("Condo");
                break;
            case "MANUFACTURED":
                setPropTypeName("Manufactured Home");
                break;
            case "DUPLEX":
                setPropTypeName("Duplex (2 UNITS)");
                break;
            case "TRIPLEX":
                setPropTypeName("Triplex (3 UNITS)");
                break;
            case "FOURPLEX":
                setPropTypeName("Quadplex (4 UNITS)");
                break;
            //no default
        }

        // Below switch statement set the occupancy in the no match product table
        switch (userSession.getPropertyUse()) {
            case "1":
                setPropUsed("Primary Home");
                break;
            case "2":
                setPropUsed("Investment Property");

                break;
            case "3":
                setPropUsed("Secondary Home");
                break;
            //no default
        }

        // Set loan to value
        if (userSession.getLoanPurpose() == "0") {
            loanAmount = Number(userSession.getPurchasePrice()) - Number(userSession.getDownPaymentAmount());
            setLtv(loanAmount / userSession.getPurchasePrice());
        }

        if (userSession.getLoanPurpose() == "1" || userSession.getLoanPurpose() == "2") {
            loanAmount = Number(userSession.getCurrentLoanBalance()) + Number(userSession.getCashOutAmount());

            var loanLtv = Number(userSession.getCurrentLoanBalance()) / Number(userSession.getEstimatedValue());
            setLtv(loanLtv);
        }

        setLoading(true);
        axios.post(process.env.REACT_APP_SUNSOFT_API_PRICE_SCENARIO_, {
            "loanAmount": loanAmount > 0 ? loanAmount : "",
            "loanPurpose": userSession.getLoanPurpose(),
            "downPayment": userSession.getDownPaymentAmount(),
            "propertyValue": userSession.getPurchasePrice() > 0 ? userSession.getPurchasePrice() : userSession.getEstimatedValue(),
            "currentLoanBalance": userSession.getCurrentLoanBalance(),
            "propertyTypeKeyword": userSession.getPropertyType(),
            "occupancy": userSession.getPropertyUse(),
            "propertyState": userSession.getPropertyState(),
            "propertyCounty": userSession.getPropertyCounty() !== "" ? userSession.getPropertyCounty() : countyCode,
            "propertyZipCode": userSession.getPropertyZipCode(),
            "creditScore": userSession.getCreditScore(),
            "price": userSession.getNoClosingCosts() == "true" && themeLeadSource !== "BANKRATE.COM" ? priceForStateConfig.getPriceForState() : 100,
            "veteran": userSession.getVeteran(),
            "leadSource": themeConfig.requestRates.leadSource,
            "promoCode": themeConfig.requestRates.promoCode,
            "userId": themeConfig.requestRates.userId,
            "branchCode": themeConfig.requestRates.branch,
            "lockPeriod": themeConfig.requestRates.lockPeriod,
            "matchExactPrice": userSession.getNoClosingCosts() == "false" ? true : themeConfig.requestRates.matchExactPrice
        }, {
            headers: { 'Content-Type': 'application/json' }
        }).then(function (response) {
            // from the response get all the products that are a match
            // productList  contains the list of products that came on the response for which we have a match
            Object.keys(response.data).forEach(function (key) {
                if (response.data[key].match == true) {
                    productsList.push(response.data[key]);
                    // 06/30/2020 Dennis, I do not want to do this but for the time been will apply this patch.
                    // ideally the U/I should iterate productsList and render the products dynamically.
                    // I am just following what was implemented to get this out quick.
                    switch (response.data[key].loanType.toUpperCase()) {
                        case "CONVENTIONAL":
                            switch (response.data[key].loanTerm) {
                                case 15:
                                    setConv15A(response.data[key]);
                                    break;
                                case 30:
                                    setConv30A(response.data[key]);
                                    break;
                                // no default
                            }
                            break;
                        case "FHA":
                            switch (response.data[key].loanTerm) {
                                case 15:
                                    setFha15A(response.data[key]);
                                    break;
                                case 30:
                                    setFha30A(response.data[key]);
                                    break;
                                // no default
                            }
                            break;
                        case "VA":
                            switch (response.data[key].loanTerm) {
                                case 15:
                                    setVa15A(response.data[key]);
                                    break;
                                case 30:
                                    setVa30A(response.data[key]);
                                    break;
                                // no default
                            }
                            break;
                        // no default
                        case "USDA":
                            switch (response.data[key].loanTerm) {
                                case 15:
                                    setUsda15A(response.data[key]);
                                    break;
                                case 30:
                                    setUsda30A(response.data[key]);
                                    break;
                                // no default
                            }
                            break;
                        // no default
                    }

                    if (!tabKey) {
                        // This condition is to show the correct rate tab after the first submit.
                        setDefaultTab(Object.values(response.data)[0].loanType.toLowerCase());
                        handleResultsProdTabs(Object.values(response.data)[0].loanType.toLowerCase());
                    }
                }
            });

            // Check if there is previously selected tab saved in the local store.
            if (tabKey) {
                // matchedProduct  contains the list of products loan type that came on the response for which we have a match
                var matchedProduct = productsList.map(function (product) {
                    return product.loanType.toLowerCase();
                });

                //Check if the previously selected tab match any loan type n the matchedProduct array
                if (matchedProduct.includes(tabKey)) {
                    handleResultsProdTabs(tabKey);
                } else {
                    setDefaultTab(Object.values(productsList)[0].loanType.toLowerCase());
                    handleResultsProdTabs(Object.values(productsList)[0].loanType.toLowerCase());
                }
            } else {
                // This condition is to show the correct rate tab after the first submit, if there is no tab saved in the local store.
                setDefaultTab(Object.values(productsList)[0].loanType.toLowerCase());
                handleResultsProdTabs(Object.values(productsList)[0].loanType.toLowerCase());
            }

            // sort the products in ascending order (low rates first)
            productsList.sort(function (a, b) {
                return a.rate - b.rate;
            });
            userSession.setWebOffer(JSON.stringify(productsList));
            setProductsList(productsList);

            setLoading(false);
        }).catch(function (error) {
            setLoading(false);
            console.log(error);
        });
    }, []);

    return React.createElement(
        React.Fragment,
        null,
        React.createElement(PulseLoader, {
            css: override,
            size: 15,
            color: "#0069d9",
            loading: loading,
            className: 'text-center'
        }),
        React.createElement(
            Row,
            { className: !loading ? "d-flex justify-content-center" : "d-none" },
            React.createElement(
                Col,
                { lg: 12, id: 'productResult', className: 'productResult' },
                React.createElement(
                    Container,
                    { className: 'ratesSection' },
                    React.createElement(
                        'div',
                        { className: !show ? "d-none" : null },
                        productsList.length !== 0 ? React.createElement(
                            Tabs,
                            { className: 'justify-content-center m-auto', activeKey: tabKey ? tabKey : defaultTab, id: 'products-tabs', transition: false, onSelect: function onSelect(k) {
                                    return handleResultsProdTabs(k);
                                } },
                            conv15A || conv30A ? React.createElement(
                                Tab,
                                { as: Row, className: showCvnRates ? "d-flex justify-content-center convRates" : "d-none convRates", eventKey: 'conventional', title: 'Conventional' },
                                conv15A.match === true ? React.createElement(
                                    Col,
                                    { lg: conv15A.rate === conv15A.apr || conv15A.apr == 0 || noCCProgram == "true" || conv15A.apr - conv15A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_conv15A', leadSource: themeLeadSource, data: conv15A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '15 YR FIXED'
                                        ),
                                        conv15A.rate === conv15A.apr || conv15A.apr == 0 || noCCProgram == "true" || conv15A.apr - conv15A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: conv15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: conv15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: conv15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-med pt-0', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            conv15A.rate === conv15A.apr || conv15A.apr == 0 || noCCProgram == "true" || conv15A.apr - conv15A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: conv15A.PI > 0 ? "textBlue poppins-black" : "d-none" },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: conv15A.PI, displayType: 'text', prefix: '$', thousandSeparator: true, decimalScale: 2, fixedDecimalScale: true })
                                            )
                                        ),
                                        conv15A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null,
                                conv30A.match === true ? React.createElement(
                                    Col,
                                    { lg: conv30A.rate === conv30A.apr || conv30A.apr == 0 || noCCProgram == "true" || conv30A.apr - conv30A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_conv30A', leadSource: themeLeadSource, data: conv30A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '30 YR FIXED'
                                        ),
                                        conv30A.rate === conv30A.apr || conv30A.apr == 0 || noCCProgram == "true" || conv30A.apr - conv30A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: conv30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: conv30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: conv30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-med pt-0', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            conv30A.rate === conv30A.apr || conv30A.apr == 0 || noCCProgram == "true" || conv30A.apr - conv30A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: conv30A.PI > 0 ? "textBlue poppins-black" : "d-none" },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: conv30A.PI, displayType: 'text', prefix: '$', thousandSeparator: true, decimalScale: 2, fixedDecimalScale: true })
                                            )
                                        ),
                                        conv30A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null
                            ) : null,
                            fha15A || fha30A ? React.createElement(
                                Tab,
                                { as: Row, className: showFHARates ? "d-flex justify-content-center fhaRates" : "d-none fhaRates", eventKey: 'fha', title: 'FHA' },
                                fha15A.match === true ? React.createElement(
                                    Col,
                                    { lg: fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_fha15A', leadSource: themeLeadSource, data: fha15A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '15 YR FIXED'
                                        ),
                                        fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: fha15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: fha15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: fha15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'fontSizeRateAprText textBlue poppins-med', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            fha15A.rate === fha15A.apr || fha15A.apr == 0 || fha15A.apr - fha15A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: fha15A.PI > 0 ? "textBlue poppins-black" : "d-none" },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: fha15A.PI, displayType: 'text', prefix: '$', thousandSeparator: true, decimalScale: 2, fixedDecimalScale: true })
                                            )
                                        ),
                                        fha15A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null,
                                fha30A.match === true ? React.createElement(
                                    Col,
                                    { lg: fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_fha30A', leadSource: themeLeadSource, data: fha30A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '30 YR FIXED'
                                        ),
                                        fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: fha30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: fha30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: fha30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'fontSizeRateAprText textBlue poppins-med', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            fha30A.rate === fha30A.apr || fha30A.apr == 0 || fha30A.apr - fha30A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-black' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: fha30A.PI, displayType: 'text', thousandSeparator: true, prefix: '$', decimalScale: 2, fixedDecimalScale: true })
                                            )
                                        ),
                                        fha30A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-med', style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null
                            ) : null,
                            va15A || va30A ? React.createElement(
                                Tab,
                                { as: Row, className: showVARates ? "d-flex justify-content-center convRates" : "d-none", eventKey: 'va', title: 'VA' },
                                va15A.match === true ? React.createElement(
                                    Col,
                                    { lg: va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_va15A', leadSource: themeLeadSource, data: va15A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '15 YR FIXED'
                                        ),
                                        va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: va15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: va15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: va15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-med pt-0', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            va15A.rate === va15A.apr || va15A.apr == 0 || va15A.apr - va15A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: va15A.PI > 0 ? "textBlue poppins-black" : "d-none" },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: va15A.PI, displayType: 'text', prefix: '$', decimalScale: 2, thousandSeparator: true, fixedDecimalScale: true })
                                            )
                                        ),
                                        va15A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null,
                                va30A.match === true ? React.createElement(
                                    Col,
                                    { lg: va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_va30A', leadSource: themeLeadSource, data: va30A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '30 YR FIXED'
                                        ),
                                        va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: va30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: va30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: va30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, thousandSeparator: true, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-med pt-0', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            va30A.rate === va30A.apr || va30A.apr == 0 || va30A.apr - va30A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-black' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: va30A.PI, displayType: 'text', prefix: '$', decimalScale: 2, thousandSeparator: true, fixedDecimalScale: true })
                                            )
                                        ),
                                        va30A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-med', style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null
                            ) : null,
                            (usda15A.match === true || usda30A.match === true) && themeLeadSource !== "TEXAS-TV" && themeLeadSource !== "BANKRATE.COM" ? React.createElement(
                                Tab,
                                { as: Row, className: showUsdaRates ? "d-flex justify-content-center convRates" : "d-none convRates", eventKey: 'usda', title: 'USDA' },
                                usda15A.match === true ? React.createElement(
                                    Col,
                                    { lg: usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center mb-3 mb-sm-3 mb-lg-0 pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_usda15A', leadSource: themeLeadSource, data: usda15A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '15 YR FIXED'
                                        ),
                                        usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: usda15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: usda15A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: usda15A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'fontSizeRateAprText textBlue poppins-med pt-0', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            usda15A.rate === usda15A.apr || usda15A.apr == 0 || usda15A.apr - usda15A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: usda15A.PI > 0 ? "textBlue poppins-black" : "d-none" },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: usda15A.PI, displayType: 'text', prefix: '$', thousandSeparator: true, decimalScale: 2, fixedDecimalScale: true })
                                            )
                                        ),
                                        usda15A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null,
                                usda30A.match === true ? React.createElement(
                                    Col,
                                    { lg: usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= .05 ? 3 : 5, className: 'textBlue poppins-black text-center pt-3' },
                                    React.createElement(
                                        ApplyNow,
                                        { id: 'appNow_usda30A', leadSource: themeLeadSource, data: usda30A },
                                        React.createElement(
                                            'h4',
                                            { className: 'textBlue poppins-bold' },
                                            '30 YR FIXED'
                                        ),
                                        usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= .05 ? React.createElement(
                                            'h2',
                                            { className: 'reducefontSize' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: usda30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                            )
                                        ) : React.createElement(
                                            'div',
                                            null,
                                            React.createElement(
                                                'h2',
                                                { className: 'reducefontSize' },
                                                React.createElement(
                                                    'strong',
                                                    null,
                                                    React.createElement(NumberFormat, { value: usda30A.rate, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true }),
                                                    ' / ',
                                                    React.createElement(NumberFormat, { value: usda30A.apr, displayType: 'text', suffix: '%', decimalScale: 3, fixedDecimalScale: true })
                                                )
                                            )
                                        ),
                                        React.createElement(
                                            'h4',
                                            { className: 'fontSizeRateAprText textBlue poppins-med pt-0', style: { fontSize: "1rem" } },
                                            '(Rate ',
                                            usda30A.rate === usda30A.apr || usda30A.apr == 0 || usda30A.apr - usda30A.rate <= .05 ? "&" : "/",
                                            ' APR)'
                                        ),
                                        userSession.getNoClosingCosts() === "true" ? null : React.createElement(
                                            'h4',
                                            { className: usda30A.PI > 0 ? "textBlue poppins-black" : "d-none" },
                                            React.createElement(
                                                'strong',
                                                null,
                                                React.createElement(NumberFormat, { value: usda30A.PI, displayType: 'text', prefix: '$', decimalScale: 2, thousandSeparator: true, fixedDecimalScale: true })
                                            )
                                        ),
                                        usda30A.PI > 0 && userSession.getNoClosingCosts() === "false" ? React.createElement(
                                            'h4',
                                            { style: { fontSize: "1rem" } },
                                            '(Estimated Monthly Payment)'
                                        ) : null,
                                        React.createElement(
                                            'h3',
                                            { className: 'lbl-Apply' },
                                            React.createElement(
                                                'strong',
                                                null,
                                                themeLeadSource == "BANKRATE.COM" ? "Get Quote" : "Apply Now"
                                            )
                                        )
                                    )
                                ) : null
                            ) : null
                        ) : null
                    )
                )
            ),
            React.createElement('span', { ref: myRefRD }),
            React.createElement(
                Row,
                { className: 'd-flex justify-content-center' },
                !loading && productsList.length !== 0 ? React.createElement(
                    Col,
                    { lg: 12 },
                    React.createElement('hr', null)
                ) : null,
                React.createElement(
                    Col,
                    { xs: '10', md: '8', className: 'mt-1 ratesTitle text-center mainBody', style: { color: "rgb(14, 62, 155)" } },
                    React.createElement(
                        'h6',
                        { className: 'mb-0' },
                        'Rates are subject to change without notice. Not all applicants will qualify. Interest Rate and APR as of\xA0',
                        shortDate,
                        '.'
                    )
                ),
                React.createElement(
                    Col,
                    { lg: 12 },
                    React.createElement('hr', null)
                )
            )
        ),
        React.createElement(
            Row,
            { className: !loading && countyName ? "d-flex justify-content-center" : "d-none" },
            React.createElement('span', { ref: myRefRD }),
            !loading && productsList.length === 0 ? React.createElement(
                Col,
                { lg: 10 },
                React.createElement(
                    'h4',
                    null,
                    'We are unable to display any products at this time. Please call us at ',
                    React.createElement(
                        'a',
                        { href: props.phoneNumber, className: 'text-decoration-none' },
                        props.phoneText
                    ),
                    ' to discuss more options.'
                )
            ) : "",
            !loading && productsList.length !== 0 ? React.createElement(
                Col,
                { lg: 12 },
                React.createElement(
                    'h5',
                    null,
                    'The above rate quote was based on the following:'
                )
            ) : "",
            React.createElement(
                Col,
                { lg: 6, className: 'mt-1' },
                React.createElement(
                    Table,
                    { responsive: 'sm', bordered: true, hover: false, className: ' mb-0 text-center textBlue' },
                    React.createElement(
                        'tbody',
                        null,
                        loanTypeName ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Loan Purpose'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                loanTypeName
                            )
                        ) : null,
                        userSession.getPurchasePrice() > 0 ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Purchase Price'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                React.createElement(NumberFormat, { value: userSession.getPurchasePrice(), displayType: 'text', thousandSeparator: true, prefix: '$',
                                    decimalScale: 0, fixedDecimalScale: false })
                            )
                        ) : null,
                        userSession.getDownPaymentAmount() > 0 ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Down Payment'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                React.createElement(NumberFormat, { value: userSession.getDownPaymentAmount(), displayType: 'text', thousandSeparator: true, prefix: '$',
                                    decimalScale: 0, fixedDecimalScale: false })
                            )
                        ) : null,
                        userSession.getCurrentLoanBalance() > 0 ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Current Loan Balance'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                React.createElement(NumberFormat, { value: userSession.getCurrentLoanBalance(), displayType: 'text', thousandSeparator: true, prefix: '$',
                                    decimalScale: 0, fixedDecimalScale: false })
                            )
                        ) : null,
                        userSession.getCashOutAmount() > 0 ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Cash Out Amount'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                React.createElement(NumberFormat, { value: userSession.getCashOutAmount(), displayType: 'text', thousandSeparator: true, prefix: '$',
                                    decimalScale: 0, fixedDecimalScale: false })
                            )
                        ) : null,
                        userSession.getEstimatedValue() > 0 ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Estimated Home Value'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                React.createElement(NumberFormat, { value: userSession.getEstimatedValue(), displayType: 'text', thousandSeparator: true, prefix: '$',
                                    decimalScale: 0, fixedDecimalScale: false })
                            )
                        ) : null,
                        ltv ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Loan to Value'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                React.createElement(NumberFormat, { value: ltv * 100, displayType: 'text', thousandSeparator: false, suffix: '%',
                                    decimalScale: 0, fixedDecimalScale: false })
                            )
                        ) : null,
                        userSession.getPropertyZipCode() ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Property ZipCode'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                userSession.getPropertyZipCode()
                            )
                        ) : null,
                        userSession.getPropertyCounty() ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Property County'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                countyName
                            )
                        ) : null,
                        userSession.getPropertyState() ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Property State'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                userSession.getPropertyState()
                            )
                        ) : null,
                        userSession.getCreditScore() ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Credit Score'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                userSession.getCreditScore()
                            )
                        ) : null,
                        propTypeName ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Property Type'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                propTypeName
                            )
                        ) : null,
                        propUsed ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Property Used'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                propUsed
                            )
                        ) : null,
                        userSession.getVeteran() ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Are You a Veteran?'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                userSession.getVeteran() == "true" ? "Yes" : "No"
                            )
                        ) : null,
                        userSession.getNoClosingCosts() == "true" ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'No Closing Costs'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                userSession.getNoClosingCosts() == "true" ? "Yes" : "No"
                            )
                        ) : null,
                        userSession.getNoClosingCosts() == "false" ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Lower Monthly Payment'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                userSession.getNoClosingCosts() == "false" ? "Yes" : "No"
                            )
                        ) : null,
                        themeLeadSource == "TEXAS-TV" ? React.createElement(
                            'tr',
                            null,
                            React.createElement(
                                'th',
                                { className: 'textBlue poppins-med' },
                                React.createElement(
                                    'h5',
                                    null,
                                    'Subordinate Financing'
                                )
                            ),
                            React.createElement(
                                'td',
                                null,
                                'No'
                            )
                        ) : null
                    )
                )
            ),
            React.createElement(
                Col,
                { lg: 12 },
                React.createElement(
                    Button,
                    { className: 'cyanButton', onClick: function onClick() {
                            return props.jumpToStep(0);
                        } },
                    'Change Quote'
                )
            )
        )
    );
}